function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.5,
  cy: 11.5,
  r: 7,
  stroke: "#87949E"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 14V12.5C11.5 11.9477 11.9745 11.5207 12.459 11.2555C13.0793 10.9159 13.5 10.2571 13.5 9.5C13.5 8.39543 12.6046 7.5 11.5 7.5C10.5681 7.5 9.72202 8.13739 9.5 9",
  stroke: "#87949E"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 15,
  width: 1,
  height: 1,
  fill: "#87949E"
});

var SvgIconQuestion = function SvgIconQuestion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconQuestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconQuestion.f4ee8792.svg";
export { ForwardRef as ReactComponent };